import { atom } from "jotai"

export interface BannerAtom {
  id: number
  title: string
  desc: string
  link: string
  img_url: string
  btn_text: string
}

export const bannersAtom = atom<BannerAtom[]>([])
